import {
    consentCategories,
    IOneTrustMobile,
    OneTrustConfigMobile,
    OneTrustConsent,
} from '../types';

export class OneTrustMobile implements IOneTrustMobile {
    protected sdk?: typeof import('react-native-onetrust-cmp').default;

    async init(config?: OneTrustConfigMobile) {
        if (!config?.enabled || !config.storageLocation || !config.appId) return;

        const sdk = (await import('react-native-onetrust-cmp'))?.default;
        if (!sdk) return;

        await sdk.startSDK(
            config.storageLocation,
            config.appId,
            config?.languageCode || 'en',
            {},
            false
        );
        this.sdk = sdk;
    }

    showPreferenceModal() {
        this.sdk?.showPreferenceCenterUI({});
    }

    async checkAndShowBanner() {
        const { sdk } = this;
        if (!sdk) return;
        if (await sdk.shouldShowBanner()) {
            sdk.showBannerUI({});
        }
    }

    private static extractConsent(javascriptCode: string): {
        tcString: string | undefined;
        gppString: string | undefined;
        gppSid: string | undefined;
    } | null {
        try {
            if (typeof javascriptCode !== 'string') return null;
            if (!javascriptCode.startsWith('var OTExternalConsent = {')) return null;
            return JSON.parse(javascriptCode.substring(24));
        } catch {
            return null;
        }
    }

    async getConsentStatus(): Promise<OneTrustConsent> {
        const { sdk } = this;
        if (!sdk) {
            return {
                limitAdvertisementTracking: null,
                doNotTrack: null,
                tcfConsentString: null,
            };
        }

        const categoryPromises = consentCategories.map((categoryId) =>
            sdk.getConsentStatusForCategory(categoryId)
        );
        const categoryResults = await Promise.all(categoryPromises);
        const personalAds = categoryResults.some((result) => result === 1);

        const domainInfo = await sdk.getDomainInfo();
        const webviewJs = await sdk.getOTConsentJSForWebView();
        const {
            tcString: tcfConsentString = null,
            gppString = null,
            gppSid = null,
        } = OneTrustMobile.extractConsent(webviewJs) || {};
        /* eslint-disable @typescript-eslint/dot-notation */
        const gppConsentString = domainInfo['countryCode'] === 'US' ? gppString : '';
        const gppSectionId = domainInfo['countryCode'] === 'US' ? gppSid : '';

        return {
            doNotTrack: !personalAds,
            limitAdvertisementTracking: !personalAds,
            tcfConsentString: tcfConsentString || null,
            gppConsentString: gppConsentString || null,
            gppSectionId: gppSectionId || null,
        };
    }
}
